class TextReadMore extends HTMLElement {
  connectedCallback() {
    const lineClamp = parseInt(this.dataset.lineClamp, 10);
    if (!lineClamp) return;

    const content = this.firstElementChild;
    if (!content) return;

    content.style.setProperty('--line-clamp', lineClamp);
    content.classList.add('text-block--clamped');

    const btn = document.createElement('button');
    btn.className = 'text-read-more__btn';
    btn.textContent = this.dataset.readMore || 'Read more';
    btn.type = 'button';
    this.appendChild(btn);

    let expanded = false;
    btn.addEventListener('click', () => {
      expanded = !expanded;
      if (expanded) {
        content.classList.remove('text-block--clamped');
        btn.textContent = this.dataset.readLess || 'Show less';
      } else {
        content.classList.add('text-block--clamped');
        btn.textContent = this.dataset.readMore || 'Read more';
      }
    });
  }
}

customElements.define('text-read-more', TextReadMore);
